import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Briefcase, Users, TrendingUp, Heart, MapPin, Phone, Mail } from 'lucide-react';

const CareersPage = () => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    resume: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    const message = `Career Application from ${formData.name}. Email: ${formData.email}. Phone: ${formData.phone}. ${formData.resume}`;
    window.open(`https://wa.me/971585862103?text=${encodeURIComponent(message)}`, '_blank');
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <section 
        className="relative h-[500px] bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=1920&q=80)',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-transparent"></div>
        <div className="relative h-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center">
          <div className="max-w-2xl">
            <h1 className="text-5xl lg:text-6xl font-bold text-white mb-6">
              {t('careersHeroTitle')}
            </h1>
            <p className="text-xl text-white/90 mb-8">
              {t('careersHeroSubtitle')}
            </p>
            <a
              href="#careers-form"
              className="inline-block bg-gradient-to-r from-logo-blue to-logo-cyan text-white px-8 py-4 rounded-lg font-semibold text-lg hover:shadow-xl transition-all"
            >{t('applyNow')}</a>
          </div>
        </div>
      </section>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        
        <div className="mb-16">
          <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">{t('careersWhyJoinTitle')}</h2>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <Briefcase className="w-16 h-16 text-logo-blue mx-auto mb-4" />
              <h3 className="text-xl font-bold text-gray-900 mb-3">{t('careersReason1Title')}</h3>
              <p className="text-gray-600">
                {t('careersReason1Desc')}
              </p>
            </div>

            <div className="text-center">
              <Users className="w-16 h-16 text-logo-blue mx-auto mb-4" />
              <h3 className="text-xl font-bold text-gray-900 mb-3">{t('careersReason2Title')}</h3>
              <p className="text-gray-600">
                {t('careersReason2Desc')}
              </p>
            </div>

            <div className="text-center">
              <TrendingUp className="w-16 h-16 text-logo-blue mx-auto mb-4" />
              <h3 className="text-xl font-bold text-gray-900 mb-3">{t('careersReason3Title')}</h3>
              <p className="text-gray-600">
                {t('careersReason3Desc')}
              </p>
            </div>

            <div className="text-center">
              <Heart className="w-16 h-16 text-logo-blue mx-auto mb-4" />
              <h3 className="text-xl font-bold text-gray-900 mb-3">{t('careersReason4Title')}</h3>
              <p className="text-gray-600">
                {t('careersReason4Desc')}
              </p>
            </div>
          </div>
        </div>

        <div className="mb-16 bg-blue-50 p-8 rounded-lg">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">{t('careersVacanciesTitle')}</h2>
          <div className="space-y-6">
            <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
              <h3 className="text-xl font-bold text-gray-900 mb-2">{t('careersJob1Title')}</h3>
              <p className="text-gray-600 mb-4">
                {t('careersJob1Desc')}
              </p>
              <div className="flex flex-wrap gap-4 text-sm">
                <span className="bg-blue-100 text-logo-blue px-3 py-1 rounded-full font-medium">{t('careersJob1Tag1')}</span>
                <span className="bg-green-100 text-green-700 px-3 py-1 rounded-full font-medium">{t('careersJob1Tag2')}</span>
                <span className="bg-gray-100 text-gray-700 px-3 py-1 rounded-full font-medium">{t('careersJob1Tag3')}</span>
              </div>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
              <h3 className="text-xl font-bold text-gray-900 mb-2">{t('careersJob2Title')}</h3>
              <p className="text-gray-600 mb-4">
                {t('careersJob2Desc')}
              </p>
              <div className="flex flex-wrap gap-4 text-sm">
                <span className="bg-blue-100 text-logo-blue px-3 py-1 rounded-full font-medium">{t('careersJob1Tag1')}</span>
                <span className="bg-green-100 text-green-700 px-3 py-1 rounded-full font-medium">{t('careersJob1Tag2')}</span>
                <span className="bg-gray-100 text-gray-700 px-3 py-1 rounded-full font-medium">{t('careersJob2Tag3')}</span>
              </div>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
              <h3 className="text-xl font-bold text-gray-900 mb-2">{t('careersJob3Title')}</h3>
              <p className="text-gray-600 mb-4">
                {t('careersJob3Desc')}
              </p>
              <div className="flex flex-wrap gap-4 text-sm">
                <span className="bg-blue-100 text-logo-blue px-3 py-1 rounded-full font-medium">{t('careersJob1Tag1')}</span>
                <span className="bg-green-100 text-green-700 px-3 py-1 rounded-full font-medium">{t('careersJob1Tag2')}</span>
                <span className="bg-gray-100 text-gray-700 px-3 py-1 rounded-full font-medium">{t('careersJob3Tag3')}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 mb-16">
          <div id="careers-form">
            <h2 className="text-3xl font-bold text-gray-900 mb-8">{t('careersFormTitle')}</h2>
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label htmlFor="name" className="block text-sm font-semibold text-gray-700 mb-2">
                  {t('contactName')} *
                </label>
                <input
                  type="text"
                  id="name"
                  required
                  value={formData.name}
                  onChange={(e) => setFormData({...formData, name: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-logo-blue focus:border-transparent"
                  placeholder={t('contactNamePlaceholder')}
                />
              </div>
              
              <div>
                <label htmlFor="email" className="block text-sm font-semibold text-gray-700 mb-2">
                  {t('affiliateFormEmail')} *
                </label>
                <input
                  type="email"
                  id="email"
                  required
                  value={formData.email}
                  onChange={(e) => setFormData({...formData, email: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-logo-blue focus:border-transparent"
                  placeholder={t('affiliateFormEmailPlaceholder')}
                />
              </div>
              
              <div>
                <label htmlFor="phone" className="block text-sm font-semibold text-gray-700 mb-2">
                  {t('contactPhone')} *
                </label>
                <input
                  type="tel"
                  id="phone"
                  required
                  value={formData.phone}
                  onChange={(e) => setFormData({...formData, phone: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-logo-blue focus:border-transparent"
                  placeholder={t('contactPhonePlaceholder')}
                />
              </div>
              
              <div>
                <label htmlFor="resume" className="block text-sm font-semibold text-gray-700 mb-2">
                  {t('careersFormResume')} *
                </label>
                <textarea
                  id="resume"
                  required
                  rows="6"
                  value={formData.resume}
                  onChange={(e) => setFormData({...formData, resume: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-logo-blue focus:border-transparent"
                  placeholder={t('careersFormResumePlaceholder')}
                ></textarea>
              </div>
              
              <button
                type="submit"
                className="w-full bg-gradient-to-r from-logo-blue to-logo-cyan text-white px-8 py-4 rounded-lg font-semibold text-lg hover:shadow-xl transition-all"
              >
                {t('careersFormSendBtn')}
              </button>
            </form>
          </div>

          <div>
            <h2 className="text-3xl font-bold text-gray-900 mb-8">{t('careersGetInTouchTitle')}</h2>
            
            <div className="space-y-6">
              <div className="flex gap-4">
                <div className="flex-shrink-0">
                  <MapPin className="w-6 h-6 text-logo-blue" />
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 mb-2">{t('contactCompanyName')}</h3>
                  <p className="text-gray-600 mb-1">{t('contactAddress1')}</p>
                  <p className="text-gray-600 mb-1">{t('contactAddress2')}</p>
                  <p className="text-gray-600">{t('contactAddress3')}</p>
                </div>
              </div>

              <div className="flex gap-4">
                <div className="flex-shrink-0">
                  <Phone className="w-6 h-6 text-logo-blue" />
                </div>
                <div>
                  <a href="tel:+971585862103" className="text-gray-900 hover:text-logo-blue font-semibold transition-colors text-lg">
                    +971 58 586 2103
                  </a>
                </div>
              </div>

              <div className="flex gap-4">
                <div className="flex-shrink-0">
                  <Mail className="w-6 h-6 text-logo-blue" />
                </div>
                <div>
                  <a href="mailto:info@thevisagram.ae" className="text-gray-900 hover:text-logo-blue font-semibold transition-colors text-lg">
                    info@thevisagram.ae
                  </a>
                </div>
              </div>
            </div>

            <div className="mt-8 p-6 bg-blue-50 rounded-lg">
              <h3 className="font-bold text-gray-900 mb-3">{t('careersJoinTeamTitle')}</h3>
              <p className="text-gray-700">
                {t('careersJoinTeamDesc')}
              </p>
            </div>
          </div>
        </div>

      </div>

      <Footer />
    </div>
  );
};

export default CareersPage;
